/////////////////////////////////////////////////////////////////////////////////////////////////////////
//FileName: work-plan.js
//FileType: Javascript Source file
//Size : ?
//Author : Harun Durmuş
//Created On : 11.12.2020 14:51
//Last Modified On : ?
//Copy Rights : Oceannet
//Description : Catalog>Work Plan Component
////////////////////////////////////////////////////////////////////////////////////////////////////////
import React from "react";
import $ from "jquery";
import Table from "./Table";
import Detail from "./Detail";
import Edit from "./Edit";
import RowDeleteModal from "../../modal/rowDelete";
// import AddWorkPlanModal from "./modals/AddWorkPlanModal";
import SelecterenDirectievoerder from "./modals/SelecterenDirectievoerder";
import ToevoegenToezichthouder from "./modals/ToevoegenToezichthouder";
import ToevoegenUitvoerder from "./modals/ToevoegenUitvoerder";
import * as CommonFunctions from "./functions/commonFunctions";
import AddPlanningPeriodModal from "./modals/AddPlanningPeriodModal";
import "./variable/v";

class WorkPlans extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: null,
    };
  }

  async componentDidMount() {
    //** ekranin herhangi̇ bi̇ryeri̇ne tiklaninca popup kaldirma i̇çi̇n kullanilan fonksi̇yon */
    $(document)
      .unbind("mouseup")
      .mouseup(function (e) {
        var popup = $("#myPopup");
        if (
          !$("div.popup").is(e.target) &&
          !popup.is(e.target) &&
          popup.has(e.target).length === 0
        ) {
          $("#myPopup").html("");
          var popup = document.getElementById("myPopup");
          $("#myPopup").removeClass("show");
        }
      });
  }

  render() {
    return (
      <div>
        <div className="border p-3 br5 full-width" id="border-mid">
          <Table {...this.props} />
          <Detail />
          <Edit />
          <AddPlanningPeriodModal />
          <SelecterenDirectievoerder />
          <ToevoegenToezichthouder />
          <ToevoegenUitvoerder />
          <RowDeleteModal
            id="work-plans-mappen_beheren_delete_modal"
            handleDelete={CommonFunctions.rowsHandleDelete}
          />
        </div>
      </div>
    );
  }
}

export default WorkPlans;
